import { Div, Label, Loader, Touchable, useWindowSize } from "@grassrootly/rn-core";
import { Image, RefreshControl, ScrollView } from "react-native";
import { ICompetitionView } from "@grassrootly/api";
import { images } from "../../layout/assets";

interface CompetitionsListProps {
  loading: boolean;
  competitions: ICompetitionView[];
  onCompetitionPress: (competitionId: number, competitionName: string) => void;
  onRefresh: () => void;
}

export default function CompetitionsList({
  loading,
  competitions,
  onCompetitionPress,
  onRefresh,
}: CompetitionsListProps) {
  const { width } = useWindowSize();

  return (
    <Div classNames={["flex1"]}>
      {loading && !competitions?.length ? (
        <Div classNames={["mt-{30}"]}>
          <Loader size="large" isLoading />
        </Div>
      ) : null}

      {!loading && competitions && !competitions.length ? (
        <Div classNames={["flex1", "alignItemsCenter", "justifyContentCenter", "mt-{30}"]}>
          <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight", "mb-{8}"]}>
            No official competitions available
          </Label>
          <Label type="l3Regular" classNames={["textCenter", "colorSecondaryLight"]}>
            Check back later for upcoming competitions
          </Label>
        </Div>
      ) : null}

      <ScrollView
        refreshControl={<RefreshControl refreshing={loading} onRefresh={onRefresh} />}
      >
        {competitions
          ? competitions.map((competition) => {
              return (
                <Touchable
                  classNames={[
                    "bw-{0}",
                    "borderPrimary",
                    "flex1",
                    "alignItemsCenter",
                    "flexRow",
                    "br-{16}",
                    width > 720 ? "ph-{12}" : "",
                    width > 720 ? "pt-{16}" : "",
                    width > 720 ? "pb-{16}" : "",
                    width > 720 ? "" : "p-{10}",
                    "mv-{8}",
                    "bgSecondaryMain",
                  ]}
                  key={competition.id}
                  onPress={() => onCompetitionPress(competition.id, competition.name)}
                >
                  <Div classNames={["flexRow", "alignItemsCenter"]}>
                    <Image
                      source={
                        competition.organization_logo
                          ? { uri: competition.organization_logo }
                          : images.groupAvatar
                      }
                      style={{ width: 48, height: 48, borderRadius: 48 }}
                    />
                    <Div classNames={["ml-{12}"]}>
                      <Label type="l2Bold" numberOfLines={2}>
                        {competition.name}
                      </Label>
                      <Label type="l4Regular" classNames={["colorSecondaryLight"]}>
                        {competition.organization_name}
                      </Label>
                    </Div>
                  </Div>
                </Touchable>
              );
            })
          : null}
      </ScrollView>
    </Div>
  );
}
